import { HStack, UseDisclosureReturn } from "@chakra-ui/react"
import IconButton from "../button/IconButton"
import { AugmentationToolbarHookReturn } from "./AugmentationToolbar"
import AugmentationToolbarBreadcrumbs from "./AugmentationToolbarBreadcrumbs"

type AugmentationPanelNavProps = {
  toolbar: AugmentationToolbarHookReturn
  disclosure?: UseDisclosureReturn
}

const AugmentationPanelNav = ({
  toolbar,
  disclosure
}: AugmentationPanelNavProps) => {
  const { selectedOption } = toolbar

  return (
    <HStack w="100%" justifyContent="space-between" spacing={1}>
      <AugmentationToolbarBreadcrumbs {...toolbar} />
      {!!selectedOption?.AugmentationNavComponent && (
        <HStack ml="auto">
          <selectedOption.AugmentationNavComponent option={selectedOption} />
        </HStack>
      )}
      {!!disclosure && (
        <IconButton
          {...disclosure.getButtonProps()}
          aria-label="Close panel"
          icon="x"
          roundSize={8}
          colorScheme="blackAlpha"
          variant="ghost"
        />
      )}
    </HStack>
  )
}

export default AugmentationPanelNav
